export const LOGIN = "login";
export const LOGOUT = "logOut";
export const SAVE_SURVEY = "saveSurvey";
export const PARTNER_SERVICE_LIST = "partnerServiceList";
export const CREATE_PARTNER = "createPartner";
export const CATEGORY_LIST = "addCategory";
export const CREATE_CATEGORY = "createCategory";
export const DELETE_PARTNER = "deletePartner";
export const CREATE_SERVICE = "createService";

export const PARTNER_LIST = "partnersList";
export const CREATE_PARTNERS = "createPartners";
export const SET_AUTHENTICATION = "setAuthentication";

export const CREATE_PARTNER_MASTER = "createPartnerMaster";
export const PARTNER_MASTER_LIST = "PartnerMasterList";
export const DELETE_PARTNET_MASTER = "deletePartnerMaster";
export const UPDATE_PARTNET_MASTER = "updatePartnerMaster";
export const CREATE_SERVICE_CATEGORY_MASTER = "createServiceCategoryMaster";
export const SERVICE_CATEGORY_LIST = "serviceCategoryList";
export const DELETE_SERVICE_CATEGORY_MASTER = "deleteServiceCategoryMaster";
export const GET_SERVICE_CATEGORY_MASTER = "getServiceCategoryMaster";
export const UPDATE_SERVICE_CATEGORY_MASTER = "updateServiceCategoryMaster";
export const CREATE_USER = "createUser";
export const DELETE_MIG_USER = "deleteUser";
export const USER_LIST = "userList";
export const EDIT_PARTNER_MASTER = "editPartnerMaster";
export const GET_PARTNER_MASTER = "getPartnerMaster";
export const GET_ALL_PARTNER_MASTER = "getAllPartnerMaster";


export const CREATE_PARTNER_SERVICE = "addPartner";
export const RESET_PASSWORD = "resetPassword";
export const SERVICE_LIST = "serviceList";

export const USER_PARTNER_LIST = "userPartnerList";
export const DELETE_PARTNER_USER = "deletePartnerUser";
export const CREATE_PARTNER_USER = "createPartnerUser";
export const CHANGE_PARTNER_USER_STATUS = "changePartnerUserStatus";
export const EDIT_PARTNER_USER_STATUS = "editPartnerUserStatus";
export const GET_PARTNER_USER = "getPartnerUser";

export const EDIT_SERVICE_PARTNER = "editServcePartner";
export const GET_SERVICE_PARTNER = "getServicePartner";
export const UPDATE_SERVICE_PARTNER = "updateServicePartner";
export const QUESTIONNARIE_LIST = "questionnarieList";
export const DELETE_QUESTIONNARIE = "deleteQuestionnarie";
export const EDIT_QUESTIONNARIE = "updateQuestionnarie";
export const UPDATE_STATUS_QUESTIONNARIE = "updateStatusQuestionnarie";

export const MIG_ROLES = "migRoles";
export const PARTNER_ROLES = "partnerRoles";
export const GET_MIG_USER = "getUser";
export const EDIT_MIG_USER = "editMigUser";
export const MIG_USER_STATUS_UPDATE = "migUserStatusUpdate";
export const UPDATE_PARTNER_STATUS = "updatePartnerStatus";

export const PARTNER_PATIENT_LIST = "partnerPatientList"
export const CREATE_PARTNER_PATIENT = "createPatient"
export const GET_PARTNER_PATIENT = "getPatient"
export const DELETE_PARTNER_PATIENT = "deletePatient"
export const EDIT_PARTNER_PATIENT = "editPatient"
export const UPDATE_STATUS_PARTNER_PATIENT = "updatePartnerPatint"

export const CREATE_PATIENT_DETAILS="createPatientDetails"
export const GET_PATIENT_DETAILS="getPatientDetails"
export const EDIT_PATIENT_DETAILS="editPatientDetails" 
export const REGISTER_PATIENT="registerPatient"

export const GET_SERVEY_DETAILS = "getSurveyDetails"
export const GET_SERVEYMESAGES = "getSurveyMessages"
export const POST_SERVEYMESAGES = "postServeyMessage"
export const PERMISSION_MENU  ="getPermissionMenu"

export const GET_PARTNER_ABOUT  ="getPartnerAbout";
export const EDIT_PARTNER_ABOUT  ="editPartnerAbout";

export const SEND_RESET_LINK  ="sendPasswordReserLink"
export const VALID_TOKEN  ="isValidToken"
export const RESET_PASSWORD_EXISTING  ="resetPasswordExisting"
export const UPDATE_STATUS_SERVICE_CATEGORY ="updateServicecategoryStatus"


export const ALLCATEGRY_PARTNER  ="allcategoryPartner"
export const GET_ALL_SERVICE_NO_PAGI  ="withoutPagination"

export const PARTNER_MAPPING  ="partnerMapping"

export const UPDATE_PARTNERNAME  ="updatePartnerName"
export const PARTNER_PATIENT_SEARCH ="searchPatient"
export const UPDATE_PROFILE = "updateProfile"
export const CREATE_NOTIFICATION = "createNotification"
export const GET_MIG_USERS_COUNT = "MigUsersCount"
export const GET_PARTNERS_USERS_COUNT = "PartnersCount"
export const GET_PROFILE = "getProfile"
export const UPDATE_NOTIFICATION_STATUS = "updateNotificationStatus"
export const GET_NOTIFICATION_LIST = "getNotificationList"

export const GET_PARTNER_NOTIFICATION_LIST = "getPartnerNotification"
/* Branch */
export const CREATE_PARTNER_STORE = "createPartnerStore"
export const GET_PARTNER_STORES = "getPartnerStores"
export const GET_PARTNER_STORE = "getPartnerStore"
export const EDIT_PARTNER_STORE = "editPartnerStore"
export const UPDATE_BRANCH_STATUS = "updateBranchStatus"
export const DELETE_PARTNER_BRANCH = "deletePartnerBranch"
export const GET_NOTIFICATION = "getnotificationDetails"
export const SEND_FCM_TOKEN = "sendFCMtoken"
export const EDIT_NOTIFICATION = "editNotification"
export const DELETE_NOTIFICATOIN = "deleteNotification"
export const CHANGE_PASSWORD = "changePassword"

export const GET_PARTNER_BRNACH_LIST = "getPartnerBranchList"
export const SEND_NOTIFICATION_COUNT = "getCountofNotification"
export const UPDATE_NOIFICATION_STATUS = "updatenotification"

